import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import player from './player'

const reducer = combineReducers({
  player,
})

export const registerReducer = (state) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})

export const getState = (state) => state[REDUCER_INDEX]
export const getStatePlayer = (state) => state[REDUCER_INDEX].player

export default reducer
